import { Suspense, type ComponentType } from "react";

import { WorkspaceRouteSkeleton } from "@/components/workspace";

/**
 * Shared route helper — Suspense wrapper for lazy page components.
 * Used by __root.tsx and every family route module under src/routes/<family>/.
 */
export function withSuspense(Component: ComponentType) {
  return function SuspendedRouteComponent() {
    return (
      <Suspense fallback={<WorkspaceRouteSkeleton />}>
        <Component />
      </Suspense>
    );
  };
}
